import React, { Component } from "react";
import AppModalBs from "../../../partials/AppModalBs";

export default class DownloadReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReport: "midYear"
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isMidYearReportGenerated !== prevProps.isMidYearReportGenerated ||
        this.props.isFullYearReportGenerated !== prevProps.isFullYearReportGenerated) {
      if (!this.props.isMidYearReportGenerated && this.props.isFullYearReportGenerated) {
        this.setState({ selectedReport: "fullYear" });
      } else if (this.props.isMidYearReportGenerated) {
        this.setState({ selectedReport: "midYear" });
      }
    }
  }

  handleRadioChange = (e) => {
    this.setState({ selectedReport: e.target.value });
  }

  handleDownload = () => {
    if (!this.props.isMidYearReportGenerated && !this.props.isFullYearReportGenerated) {
      return;
    }
    if (this.props.onDownload) {
      this.props.onDownload(this.state.selectedReport);
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    let { id = "downloadReportModal", onClose, isMidYearReportGenerated = true, isFullYearReportGenerated = true } = this.props;
    
    return (
      <AppModalBs 
        id={id} 
        title={<span style={{ fontSize: '20px', lineHeight: '1.4' }}>Please select the report<br/>you want to download?</span>} 
        onClose={onClose}
        size=""
      >
        <div className="p-4 text-center">
          <div className="d-flex justify-content-center gap-4 mb-5 mt-2">
            <div className="form-check d-flex align-items-center gap-2">
              <input 
                className="form-check-input mt-0" 
                type="radio" 
                name="reportType" 
                id="reportMidYear" 
                value="midYear" 
                checked={this.state.selectedReport === "midYear"}
                onChange={this.handleRadioChange}
                disabled={!isMidYearReportGenerated}
                style={{ cursor: isMidYearReportGenerated ? 'pointer' : 'not-allowed' }}
              />
              <label className={`form-check-label fw-semibold ${isMidYearReportGenerated ? 'text-dark' : 'text-muted'}`} htmlFor="reportMidYear" style={{ cursor: isMidYearReportGenerated ? 'pointer' : 'not-allowed' }}>Mid Year</label>
            </div>
            <div className="form-check d-flex align-items-center gap-2">
              <input 
                className="form-check-input mt-0" 
                type="radio" 
                name="reportType" 
                id="reportFullYear" 
                value="fullYear" 
                checked={this.state.selectedReport === "fullYear"}
                onChange={this.handleRadioChange}
                disabled={!isFullYearReportGenerated}
                style={{ cursor: isFullYearReportGenerated ? 'pointer' : 'not-allowed' }}
              />
              <label className={`form-check-label fw-semibold ${isFullYearReportGenerated ? 'text-dark' : 'text-muted'}`} htmlFor="reportFullYear" style={{ cursor: isFullYearReportGenerated ? 'pointer' : 'not-allowed' }}>Full Year</label>
            </div>

          </div>
          
          <button 
            className="btn btn-warning text-white fw-bold px-5 py-2 w-75" 
            onClick={this.handleDownload}
            data-bs-dismiss="modal"
            disabled={!isMidYearReportGenerated && !isFullYearReportGenerated}
          >
            Download
          </button>
        </div>
      </AppModalBs>
    );
  }
}
